import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import {
  AcceptDirectorInviteDto,
  BankDirectorDto,
  BankDirectorFilter,
  CreateBankDirectorDto,
} from '../../../core/data/new-dtos/bank-director.dtos';

@Injectable({ providedIn: 'root' })
export class BankDirectorsService extends BaseCrudService<BankDirectorDto> {
  controller = 'BankDirectors';

  // GET /api/BankDirectors
  getDirectors(filter: BankDirectorFilter = {}): Observable<BankDirectorDto[]> {
    let params = new HttpParams();
    if (filter.bankId != null) params = params.set('bankId', filter.bankId);
    if (filter.role) params = params.set('role', filter.role);
    if (filter.status) params = params.set('status', filter.status);
    return this.httpClient.get<BankDirectorDto[]>(`${this.controller}`, { params });
  }

  // POST /api/BankDirectors
  invite(dto: CreateBankDirectorDto): Observable<BankDirectorDto> {
    return this.httpClient.post<BankDirectorDto>(`${this.controller}`, dto);
  }

  // PATCH /api/BankDirectors/{id}/status
  changeStatus(directorId: number, isActive: boolean): Observable<BankDirectorDto> {
    return this.httpClient.patch<BankDirectorDto>(
      `${this.controller}/${directorId}/status`,
      { isActive },
    );
  }

  // PUT /api/BankDirectors/{id}/regions
  replaceRegions(directorId: number, regionIds: number[]): Observable<BankDirectorDto> {
    return this.httpClient.put<BankDirectorDto>(
      `${this.controller}/${directorId}/regions`,
      { regionIds },
    );
  }

  // GET /api/BankDirectors/invite/me — the caller's own invite, 404 when none
  getMyInvite(): Observable<BankDirectorDto> {
    return this.httpClient.get<BankDirectorDto>(`${this.controller}/invite/me`);
  }

  // POST /api/BankDirectors/invite/accept — confirms personal info and links the account
  acceptInvite(dto: AcceptDirectorInviteDto): Observable<BankDirectorDto> {
    return this.httpClient.post<BankDirectorDto>(`${this.controller}/invite/accept`, dto);
  }

  // POST /api/BankDirectors/{id}/resend-invite — unclaimed invites only
  resendInvite(directorId: number): Observable<BankDirectorDto> {
    return this.httpClient.post<BankDirectorDto>(
      `${this.controller}/${directorId}/resend-invite`,
      {},
    );
  }

  // DELETE /api/BankDirectors/{id} — unclaimed invites only
  deleteInvite(directorId: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.controller}/${directorId}`);
  }
}
